module.exports = __webpack_public_path__ + "static/media/black-1296170_640_color.8049eefd.png";